/**
 * Created by ubuntuuser on 18-9-10.
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// 应对刷新从本地取出数据
let market = window.localStorage.getItem('market') || 0
let routeType = window.localStorage.getItem('routeType') || ''
let aid = window.localStorage.getItem('aid') || 0

const store = new Vuex.Store({
  state: {
    market: market, // 模块
    routeType: routeType, // 路由显示
    aid: aid // 公众号aid
  },
  mutations: {
    // 改变模块
    changeMarket (state, market) {
      state.market = market
      window.localStorage.setItem('market', market)
    },
    // 改变路由显示
    changeRouteType (state, routeType) {
      state.routeType = routeType
      window.localStorage.setItem('routeType', routeType)
    },
    // 公众号改变
    changeAid (state, aid) {
      state.aid = aid
      window.localStorage.setItem('aid', aid)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js